import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "../lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = window.location.hash.split("session_id=")[1]?.split("&")[0];
    (async () => {
      try {
        const { data } = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        navigate("/admin", { state: { user: data.user }, replace: true });
      } catch (e) {
        const detail = e.response?.data?.detail;
        navigate("/admin", {
          state: { authError: typeof detail === "string" ? detail : "Google sign-in failed. Try again." },
          replace: true,
        });
      }
    })();
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0B0C0E]">
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#9CA3AF]">Signing you in…</p>
    </div>
  );
}
